<template>
    <div class="page">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="banner">
                <div class="back_icon"
                     @click="goBack"></div>
            </div>
            <div class="paper_list">
                <!-- 小学语文期末测试一 -->
                <div class="paper_item"
                     v-if="yw1.length">
                    <div class="title">语文期末大检测（一）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in yw1"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/chinese/inspect/preview/task/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
                <!-- 小学语文期末测试一 -->
                <div class="paper_item"
                     v-if="yw2.length">
                    <div class="title">语文期末大检测（二）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in yw2"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/chinese/inspect/preview/task/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
                <!-- 小学数学期末测试一 -->
                <div class="paper_item"
                     v-if="sx1.length">
                    <div class="title">数学期末大检测（一）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in sx1"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/preview/task/21/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
                <!-- 小学数学期末测试一 -->
                <div class="paper_item"
                     v-if="sx2.length">
                    <div class="title">数学期末大检测（二）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in sx2"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/preview/task/21/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
                <!-- 初中数学期末测试一 -->
                <div class="paper_item"
                     v-if="msx1.length">
                    <div class="title">初中数学期末大检测（一）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in msx1"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/preview/task/21/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
                <!-- 初中数学期末测试一 -->
                <div class="paper_item"
                     v-if="msx2.length">
                    <div class="title">初中数学期末大检测（二）</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in msx2"
                             :key="index">
                            <div class="unit_name">{{item.unit_name}}</div>
                            <div class="preview"
                                 @click="handleJump('/preview/task/21/'+item.paper_id+'?hd_type='+hd_type)">预览</div>
                            <div class="btn"
                                 @click="share(item)">分享给学生</div>
                            <div class="btn view"
                                 @click="goDetail(item)">查看完成情况</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            hd_type: 10,//本次活动type
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            unitData: {},
            yw1: [],//语文试卷一
            yw2: [],//语文试卷二
            sx1: [],//小学数学试卷一
            sx2: [],//小学数学试卷二
            msx1: [],//初中小学数学试卷一
            msx2: [],//初中数学试卷二
        }
    },
    created () {
        //修改页面标题
        window.document.title = "期末大检测"
        this.$http.post(API_URL_HD_API + "/common/get_paper", {
            hd_type: this.hd_type
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.unitData = res.data
                res.data.yw_paper.forEach(e => {
                    if (e.sid == 51 && e.sequence == 1) {
                        this.yw1.push(e)
                    }
                    if (e.sid == 51 && e.sequence == 2) {
                        this.yw2.push(e)
                    }
                })
                res.data.sx_paper.forEach(e => {
                    if (e.dept_type == 1 && e.sequence == 1) {
                        this.sx1.push(e)
                    }
                    if (e.dept_type == 1 && e.sequence == 2) {
                        this.sx2.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 1) {
                        this.msx1.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 2) {
                        this.msx2.push(e)
                    }
                })
                if (this.yw1.length < 1 && this.yw2.length < 1 && this.sx1.length < 1 && this.sx2.length < 1 && this.msx1.length < 1 && this.msx2.length < 1) {
                    layer.alert('暂无试卷')
                }

            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        handleJump (url) {
            this.$router.push(url)
        },
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        share (unit) {
            let that = this
            let title = unit.school_name + (unit.sid == 21 ? "数学" : "语文") + "期末大检测";
            let content = "点击参加" + (unit.sid == 21 ? "数学" : "语文") + "期末大检测";
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${unit.wap_url},${String(unit.sid)[0]},${unit.unit_class_id},0,26,期末大检测活动分享`);
            } else {
                layer.alert('将链接分享到对应的班级群，点击链接即可参加期末大检测。', 'tea', function (index) {
                    that.copyText(`${title},${content},链接：${unit.wap_url}`)
                    layer.close(index)
                }, '分享链接复制成功')

            }

        },
        goDetail (u) {
            this.$store.commit('setTabtype', 1)
            this.$router.push(`/personaLearning?sid=${u.sid}&taskId=${u.paper_id}&classId=${u.unit_class_id}&hd_type=${this.hd_type}&dept_type=${u.dept_type}&className=${encodeURIComponent(u.unit_name)}`)
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    min-height: 757px;
    background-color: #e4f5ff;
    padding-bottom: 100px / $ppr;
    .banner {
        height: 1091px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/index.png");
        position: relative;
        .back_icon {
            top: 20px / $ppr;
            position: absolute;
            width: 86px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_01.png");
            cursor: pointer;
            opacity: 0.8;
        }
    }
    .paper_list {
        background: #fff;
        border-radius: 64px / $ppr 0 64px / $ppr 0;
        padding: 0 40px / $ppr;
        margin-top: 53px / $ppr;
        .paper_item {
            padding: 20px / $ppr 0 65px / $ppr;
            background: url("./img/line.png") no-repeat center top;
            background-size: 623px / $ppr 13px / $ppr;
            &:first-child {
                background: none;
                padding-top: 10px / $ppr;
            }
            .title {
                font-size: 36px / $ppr;
                font-weight: bold;
                color: #333;
                text-align: center;
                padding: 45px / $ppr 0 18px / $ppr;
            }
            .unit_list {
                .unit_item {
                    margin-top: 20px / $ppr;
                    border-radius: 12px / $ppr;
                    background: #f9f8f8;
                    padding: 37px / $ppr 32px / $ppr 37px / $ppr 40px / $ppr;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .unit_name {
                        font-size: 28px / $ppr;
                        font-weight: bold;
                        color: #333;
                        margin-right: 52px / $ppr;
                    }
                    .preview {
                        font-size: 28px / $ppr;
                        color: #308fff;
                    }
                    .btn {
                        height: 56px / $ppr;
                        line-height: 56px / $ppr;
                        border-radius: 56px / $ppr;
                        font-size: 24px / $ppr;
                        color: #fff;
                        background: #589dff;
                        padding: 0 18px / $ppr;
                        margin-left: 22px / $ppr;
                        &.view {
                            background: #ff855c;
                            margin-left: 18px / $ppr;
                            padding: 0 11px / $ppr;
                        }
                    }
                }
            }
        }
    }
}
</style>